import { render, staticRenderFns } from "./TenantDetails.vue?vue&type=template&id=4447c47b"
import script from "./TenantDetails.vue.ts?vue&type=script&lang=ts&external"
export * from "./TenantDetails.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports